import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {
  getPartnerIkCardSelectableIconItemForManageUsers
} from '@app/invitation/invitation-b2b/shared/helpers/ik-card-selectable-icon-item/partner/get-partner-ik-card-selectable-icon-item-for-manage-users';
import { IInvitation } from '@app/models/signup';
import { clickableElement, IClickableElement } from '@app/shared/clickable-element';
import { IIkCardSelectableIconItem, } from '@infomaniak/angular-common/src/components/ik-card-selectable-icon-item/ik-card-selectable-icon-item.interfaces';
import { translate, TranslocoService } from '@ngneat/transloco';
import {
  InvitationB2bAccessListDisplayProductsComponent,
  InvitationB2bAccessListDisplayProductsComponentData,
} from './display-products/invitation-b2b-access-list-display-products.component';

@Component({
  selector: 'app-invitation-b2b-access-list',
  templateUrl: './invitation-b2b-access-list.component.html',
  styleUrls: ['./invitation-b2b-access-list.component.scss']
})
export class InvitationB2bAccessListComponent implements OnInit {
  @Input() invitation: IInvitation;

  limitedAccess: IIkCardSelectableIconItem[];
  fullAccess: IIkCardSelectableIconItem[];

  private myClickableElement: IClickableElement;

  constructor(
    protected domSanitizer: DomSanitizer,
    private translationService: TranslocoService,
    protected dialog: MatDialog,
  ) {
  }

  get customText(): SafeHtml {
    const text = translate('Vous pourrez acceder $authorizedProducts$ par ce client.', { authorizedProducts: this.myClickableElement.html });
    return this.domSanitizer.bypassSecurityTrustHtml(text);
  }

  ngOnInit(): void {

    this.translationService.langChanges$.subscribe(() => {

      this.myClickableElement = clickableElement({
        text: translate('aux produits autorises'),
        className: 'link blue',
        callback: () => {
          this.showProducts();
        },
      });


      this.limitedAccess = [
        {
          icon: 'icon-product-gestion',
          title: translate('Gestion limitee des produits'),
          description: this.customText,
        },
        {
          ...getPartnerIkCardSelectableIconItemForManageUsers(),
          disabled: true,
        },
        {
          icon: 'icon-receipt',
          title: translate('Commandes et renouvellements'),
          description: translate('Vous ne pourrez pas commander et/ou renouveller des produits pour ce client.'),
          disabled: true,
        },
        {
          icon: 'icon-money-bag-dollar-hand',
          title: translate('Revenus'),
          description: translate('Vous percevrez un revenu lorsque votre client achete ou renouvelle un produit sur lequel vous avez des droits d\'acces.'),
          disabled: false,
        },
      ];

      this.fullAccess = [
        {
          icon: 'icon-product-gestion',
          title: translate('Gestion complete des produits'),
          description: translate('Vous aurez acces a tous les produits du client.'),
        },
        getPartnerIkCardSelectableIconItemForManageUsers(),
        {
          icon: 'icon-receipt',
          title: translate('Commandes et renouvellements'),
          description: translate('Vous pourrez commander et renouveler des produits pour ce client.'),
        },
        {
          icon: 'icon-money-bag-dollar-hand',
          title: this.invitation.extras.has_customer_payment_method ? translate('Revenus') : translate('Reduction'),
          description: this.invitation.extras.has_customer_payment_method
            ? translate('Vous percevrez un revenu lorsqu\'un achat ou un renouvellement de produit que vous gerez pour ce client est effectue.')
            : translate('Vous beneficierez d\'une reduction lors de l\'achat ou du renouvellement d\'un produit que vous gerez pour ce client.'),
        },
        {
          icon: this.invitation.extras.has_customer_payment_method
            ? 'icon-handshake' : 'icon-card-double',
          title: translate('Reglement des achats'),
          description: this.invitation.extras.has_customer_payment_method
            ? translate('Vous devrez utiliser les moyens de paiement du client pour commander ou renouveller ses produits.')
            : translate('Vous devrez utiliser vos moyens de paiement pour effectuer des commandes ou renouveller des produits pour ce client.'),
        },
      ];

    });
  }

  ngOnDestroy(): void {
    this.myClickableElement.removeClickEventListener();
  }

  showProducts(): void {
    const dialogConfig: MatDialogConfig<InvitationB2bAccessListDisplayProductsComponentData> = {
      disableClose: true,
      width: '600px',
      panelClass: ['ik-overlay-classic', 'custom-dialog-invitation'],
      data: {
        organisation: this.invitation.account.organization_name,
        products: this.invitation.extras?.products,
      },
    };

    this.dialog.open(InvitationB2bAccessListDisplayProductsComponent, dialogConfig);
  }
}
